/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/qaSetupCollapsed.ts
 * FILE_ID: JOBHUB-QA-SETUP-COLLAPSED-001
 * PURPOSE: Derive setup collapse from inspections unless the user chose.
 * WHY: usePersistentBool only reads the fallback on first mount. While
 *      inspections are still loading that fallback is false, so a job that
 *      already has QA would stay expanded after the list arrives.
 */

export const QA_SETUP_COLLAPSED_KEY = 'qa.setup.collapsed'

export function readQaSetupCollapsedStored(): string | null {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage.getItem(QA_SETUP_COLLAPSED_KEY)
  } catch {
    return null
  }
}

export function resolveQaSetupCollapsed(
  _hasInspections: boolean | undefined,
  stored: string | null | undefined,
  persisted: boolean,
): boolean {
  if (stored != null) return persisted
  return false
}
